"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusManager = void 0;
var react_1 = __importStar(require("react"));
var FocusManager = function (_a) {
    var onFocusEnter = _a.onFocusEnter, onFocusLeave = _a.onFocusLeave, children = _a.children;
    var timeoutId = (0, react_1.useRef)(undefined);
    var gotWindowMouseDown = (0, react_1.useRef)(undefined);
    var gotTargetMouseDown = (0, react_1.useRef)(undefined);
    var wait = function () {
        if (timeoutId.current !== undefined) {
            window.clearTimeout(timeoutId.current);
        }
        timeoutId.current = window.setTimeout(function () {
            if (gotWindowMouseDown.current && !gotTargetMouseDown.current) {
                onFocusLeave();
            }
            gotTargetMouseDown.current = undefined;
            gotWindowMouseDown.current = undefined;
        }, 0);
    };
    var onMouseDownCapture = function () {
        gotTargetMouseDown.current = true;
        onFocusEnter();
        wait();
    };
    var onWindowMousedown = (0, react_1.useCallback)(function () {
        gotWindowMouseDown.current = true;
        wait();
    }, []);
    (0, react_1.useEffect)(function () {
        window.addEventListener("mousedown", onWindowMousedown, { capture: true });
        return function () {
            window.removeEventListener("mousedown", onWindowMousedown, { capture: true });
        };
    }, [onWindowMousedown]);
    return react_1.default.createElement("div", { onMouseDownCapture: onMouseDownCapture }, children);
};
exports.FocusManager = FocusManager;
